module.exports = __webpack_public_path__ + "img/thumbnail_Springbok_f_normal.8698c2f7.png";